/**
 * Reads bytes as latin1 characters (one character per byte).
 * @param bytes - the bytes (read in place, not copied).
 * @param start - first byte.
 * @param length - number of bytes; clamped to the end of `bytes`.
 * @returns The characters.
 */
export function readLatin1(bytes, start, length) {
    let text = '';
    const end = Math.min(bytes.length, start + length);
    for (let i = start; i < end; i++) {
        text += String.fromCodePoint(bytes[i]);
    }
    return text;
}
/**
 * Checks that bytes start with a given signature.
 * @param bytes - the bytes.
 * @param signature - expected first bytes.
 * @returns True on a match.
 */
export function hasSignature(bytes, signature) {
    if (bytes.length < signature.length)
        return false;
    for (let i = 0; i < signature.length; i++) {
        if (bytes[i] !== signature[i])
            return false;
    }
    return true;
}
//# sourceMappingURL=bytes.js.map